var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Card',{attrs:{"title":"Net Worth","icon":"mdi-egg"}},[_vm._v(" "+_vm._s(_vm.formatMoney(_vm.accounts.reduce((a, b) => a + (b.balanceWithPending || 0), 0)))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }